import {
    LogoutDto, ReloginAuthDto, ResponseReloginAuthDto, ResponseSignInDto,
    SignInDto, SuccessResponseDto, ValidateTokenDto
} from '@/dtos';

import http from '@/helpers/apis/http-auth';
import { authHeader } from '@/helpers/utilities/auth-header';

class AuthService {
    async signIn(signInDto: SignInDto): Promise<SuccessResponseDto<ResponseSignInDto>> {
        const result = await http.post('/login', signInDto, { withCredentials: false });
        return result.data;
    }

    async generateToken(reloginAuthDto: ReloginAuthDto): Promise<SuccessResponseDto<ResponseReloginAuthDto>> {
        const result = await http.post('/generate-token', reloginAuthDto, { withCredentials: false });
        return result.data;
    }

    async validateToken(validateTokenDto: ValidateTokenDto): Promise<SuccessResponseDto<boolean>> {
        const result = await http.post('/validate-token', validateTokenDto, { withCredentials: false });
        return result.data;
    }

    async logout(logoutDto: LogoutDto): Promise<SuccessResponseDto<boolean>> {
        const result = await http.post('/logout', logoutDto, { headers: authHeader(), withCredentials: false });
        return result.data;
    }
}

export default new AuthService;